import React, { Component } from 'react';

import Point1 from '../../assets/b-img-1.png';
import Point2 from '../../assets/b-img-2.png';
import Point3 from '../../assets/b-img-3.png';
import Point4 from '../../assets/b-img-4.png';
import Point5 from '../../assets/b-img-5.png';
import Point6 from '../../assets/b-img-6.png';
import Arrow1 from '../../assets/arrow-1.png';
import Arrow2 from '../../assets/arrow-2.png';
import Arrow3 from '../../assets/arrow-3.png';
import Arrow4 from '../../assets/arrow-4.png';
import './blue-page-2.css';
import axios from '../../axios';
import { PiPlayLight } from "react-icons/pi";
import { Button } from 'react-bootstrap';
import BluePageModal from '../../component/blue-page-modal/blue-page-modal';
import Loader from '../../component/loader/loader';
import swalAlert from '../../swalFunction';

export default class Actions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showBlueModal: true,
            isInstantAwareness: false,
            loading: false
        };
    }

    componentDidMount() {
        setTimeout(() => {
            this.setState({ isInstantAwareness: Object.fromEntries(new URLSearchParams(this.props.location.search)?.entries()).rId ? true : false });
        }, 3000);
    }

    redirectToInstantAwareness = async () => {
        try {
            this.setState({loading: true});
            const params = new URLSearchParams(this.props.location.search);
            let query = Object.fromEntries(params.entries());
            let response = await axios.get(`/api/lms/get-awareness-link`, {
                params: {
                    rId: query.rId
                }
            });
            this.setState({loading: false});
            let { instantAwarenessUrl } = response.data;
            window.location.href = instantAwarenessUrl;
        } catch (error) {
            this.setState({loading: false});
            if (error && error.response && error.response.status && error.response.status === 440) {
                for (let i = 0; i < error.response.data.errors.length; i++) {
                    swalAlert('Error', error.response.data.errors[i]);
                }
            } else if (error && error.response && error.response.data && error.response.data.errors) {
                for (let i = 0; i < error.response.data.errors.length; i++) {
                    swalAlert('Error', error.response.data.errors[i]);
                }
            } else if (error.response && error.response.data && error.response.data.isJoi) {
                for (let i = 0; error.response.data.details && i < error.response.data.details.length; i++) {
                    swalAlert('Error', error.response.data.details[i].message);
                }
            } else {
                console.log("The error is: ", error);
                if (navigator.onLine) {
                    swalAlert('Error', 'Something Went Wrong!');
                } else {
                    swalAlert('Error', 'We Are Offline, Please Check Your Internet Connetion !');
                }
            }
        }
    }


    startTraining = () => {
        this.setState({ showBlueModal: true });
    }

    hideBlueModal = () => {
        this.setState({ showBlueModal: false });
    }

    render() {
        return (
            <div className="bluePageWrap" id="bluePage-2-wrap">
                <div className="col-md-10 mx-auto">
                    <h1 className="main-head">You have been Phished!</h1>
                    <h4 className="sub-head">Remember these six rules to stay safe online</h4>
                    <div className="row justify-content-center align-items-center mid-row">
                        <div className="col-md-5 col-lg-4 text-center">
                            <img src={Point1} className="img-fluid pointer" alt=""></img>
                        </div>
                        <div className="col-md-7 col-lg-6">
                            <div className="box-numeric">
                                <div className="left-unit">
                                    <div className="num-box">
                                        <span>01</span>
                                    </div>
                                </div>
                                <div className="right-unit">
                                    <h4>Protect Your Personal Info</h4>
                                    <p> Be very cautious with your personal info including usernames and passwords</p>
                                </div>
                            </div>
                            <img src={Arrow1} className="arrow-img arrow-1" alt=""></img>
                        </div>
                    </div>
                    <div className="row justify-content-end align-items-center mid-row">
                        <div className="col-md-5 col-lg-4 text-center order-md-2">
                            <img src={Point2} className="img-fluid pointer" alt=""></img>
                        </div>
                        <div className="col-md-7 col-lg-6 order-md-1">
                            <div className="box-numeric">
                                <div className="left-unit">
                                    <div className="num-box">
                                        <span>02</span>
                                    </div>
                                </div>
                                <div className="right-unit">
                                    <h4>Beware of Suspicious Emails</h4>
                                    <p> Be very suspicious of any emails you receive from trusted entities such as your bank or credit card</p>
                                </div>
                            </div>
                            <img src={Arrow2} className="arrow-img arrow-2" alt=""></img>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center mid-row">
                        <div className="col-md-5 col-lg-4 text-center">
                            <img src={Point3} className="img-fluid pointer" alt=""></img>
                        </div>
                        <div className="col-md-7 col-lg-6">
                            <div className="box-numeric">
                                <div className="left-unit">
                                    <div className="num-box">
                                        <span>03</span>
                                    </div>
                                </div>
                                <div className="right-unit">
                                    <h4>Do Not Click Suspicious Links</h4>
                                    <p>Deceptive links that mimic legitimate URL addresses are a common tool used in phishing scams</p>
                                </div>
                            </div>
                            <img src={Arrow3} className="arrow-img arrow-3" alt=""></img>
                        </div>
                    </div>
                    <div className="row justify-content-end align-items-center mid-row">
                        <div className="col-md-5 col-lg-4 text-center order-md-2">
                            <img src={Point4} className="img-fluid pointer" alt=""></img>
                        </div>
                        <div className="col-md-7 col-lg-6 order-md-1">
                            <div className="box-numeric">
                                <div className="left-unit">
                                    <div className="num-box">
                                        <span>04</span>
                                    </div>
                                </div>
                                <div className="right-unit">
                                    <h4>Know Common Phishing Language</h4>
                                    <p> Legitimate business will not send you email to ask for your login information or sensitive personal information</p>
                                </div>
                            </div>
                            <img src={Arrow4} className="arrow-img arrow-4" alt=""></img>
                        </div>
                    </div>
                    <div className="row justify-content-center align-items-center mid-row">
                        <div className="col-md-5 col-lg-4 text-center">
                            <img src={Point5} className="img-fluid pointer" alt=""></img>
                        </div>
                        <div className="col-md-7 col-lg-6">
                            <div className="box-numeric">
                                <div className="left-unit">
                                    <div className="num-box">
                                        <span>05</span>
                                    </div>
                                </div>
                                <div className="right-unit">
                                    <h4>False Sense Urgency</h4>
                                    <p> Look out for emails that try to convey a sense or urgency, and be wary of any email that does not address you directly</p>
                                </div>
                            </div>
                            <img src={Arrow3} className="arrow-img arrow-3" alt=""></img>
                        </div>
                    </div>
                    <div className="row justify-content-end align-items-center mid-row pb-5">
                        <div className="col-md-5 col-lg-4 text-center order-md-2">
                            <img src={Point6} className="img-fluid pointer" alt=""></img>
                        </div>
                        <div className="col-md-7 col-lg-6 order-md-1">
                            <div className="box-numeric">
                                <div className="left-unit">
                                    <div className="num-box">
                                        <span>06</span>
                                    </div>
                                </div>
                                <div className="right-unit">
                                    <h4>Compromised Accounts</h4>
                                    <p> Warning that your account has been compromised, for example, are a common way to lure victims</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.isInstantAwareness &&
                    <>
                        <BluePageModal showModal={this.state.showBlueModal} hideModal={this.hideBlueModal} redirectToInstantAwareness={this.redirectToInstantAwareness} />

                        {!this.state.showBlueModal && (
                            <div className='startTrainingWrap'>
                                <div className='dFlex' style={{ alignItems: 'center', gap: '12px' }}>
                                    <span className='trainingText'><PiPlayLight className='playIcon' /> Click the button to begin the course</span>
                                    <Button className='btn btn-primary' onClick={this.redirectToInstantAwareness}>Start Course</Button>
                                </div>
                            </div>
                        )}
                    </>
                }
                {this.state.loading && <Loader/>}
            </div>
        );
    }
}